import React, { createContext, useContext, useState } from 'react';

const CompanyContext = createContext();

const EMPTY = {
  name: '',
  tagline: '',
  email: '',
  phone: '',
  website: '',
  gstin: '',
  address: '',
  city: '',
  state: '',
  pincode: '',
  country: 'India',
};

export function CompanyProvider({ children }) {
  const [company, setCompany] = useState(EMPTY);
  const isComplete = !!(company.name && company.email && company.phone && company.address);
  const update = (data) => setCompany(prev => ({ ...prev, ...data }));
  return (
    <CompanyContext.Provider value={{ company, update, isComplete }}>
      {children}
    </CompanyContext.Provider>
  );
}

export const useCompany = () => useContext(CompanyContext);
